export class TimeSheetTotal {
  type: string;
  typeName: string;
  quantity: number;
  unit: string;
  total: number;
}
